import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdFreeTrialDevelopersCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/free_trial/developers/:developer_id",
  "/companies/:company_id/free_trial/developers_table",
];
